import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import CountUp from "react-countup";
import ReactPagination from "components/shared/ReactPagination";
import { DASHBOARD, PAGE_LIMIT, itemsPerPage } from "helpers/viewContent";
import { useModules } from "helpers/modules";
import { SIDEBAR_LOGIN_LOGO } from "utils/constant";

// Services
import { getApiValidityUserData, getDashboardApiCalls } from "store/services/UserDashboardService";
import { Col, Container, Row } from "react-bootstrap";
import TotalApiCallsPie from "./TotalApiCalls";
import StatusCodePieChart from "./StatusCodeChart";
import TableData from "./TableDataTotal_API_Call_LIST";
import BarChartWithData from './4xxxBarChart';
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { DATE_FORMAT_TIME_ } from "helpers/common";
import { decrypt } from "utils/Utility";
import FilterComponent from "components/shared/LogFilters";
import LogDataTable from "./LogDataTable";
import { getAdminLogData_ } from "store/services/dashboardService";

const UserDashboard = ({ dispatch, user, userProfile }) => {
    const today = new Date();
    const formattedDate = `${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}-${today.getFullYear()}`;
    const formattedMonth = today.toLocaleString('default', { month: 'long' });
    const formattedYear = today.getFullYear();
    const [logData, setLogData] = useState({});
    const [totalCount, setTotalCount] = useState(0);

    const { id } = useParams();
    const apiKey = decrypt(id);


    const [tableFilter, setTableFilter] = useState({
        page: 1,
        limit: PAGE_LIMIT,
        ip: "",
        statusCode: "",
        method: "",
        endpoint: "",
        startDate: "",
        endDate: "",
        apiKey: apiKey,
    });


    const fetchLogData = async () => {
        try {
            let query = {
                ...tableFilter
            };
            let res = await dispatch(getAdminLogData_(query));
            setTotalCount(res?.data?.data?.totalCount);
            setLogData(res?.data?.data);
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        fetchLogData();
    }, [tableFilter])




    const [filter, setFilter] = useState({
        page: 1,
        limit: PAGE_LIMIT,
        search: "",
        status: "",
        order: -1,
        orderBy: "createdAt",
    });

    const [ApiCallsList, setApiCallsList] = useState({});
    const [ApiValidityList, setApiValidityList] = useState({});

    async function getDashboardList_() {
        try {
            let query = { apiKey: apiKey };
            let res = await dispatch(getDashboardApiCalls(query));
            let res1 = await dispatch(getApiValidityUserData(query));

            if (res && res1) {
                setApiCallsList(res?.data?.data || {});
                setApiValidityList(res1?.data?.data || {});
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getDashboardList_();
    }, [id]);

    const handleDataChange = (key, value) => {
        setTableFilter((prevFilters) => ({
            ...prevFilters,
            [key]: value,
        }));
    };

    const clearFilters = () => {
        setTableFilter({
            ...tableFilter,
            ip: "",
            statusCode: "",
            method: "",
            endpoint: "",
            startDate: "",
            endDate: "",
        });
    };
    return (
        <>
            <section>
                <h2>User API Dashboard</h2>
                <Container className="my-3">
                    <Row className="mb-3">
                        {/* API Calls Summary */}
                        <Col lg={6}>
                            <div className="cardDesign p-3">
                                <h4 className="mb-2">Total API Calls</h4>
                                <div className="d-flex justify-content-between">
                                    <p>Today({formattedDate}) :</p>
                                    <p>{ApiCallsList?.Total_API_Call?.today || 0}</p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p>This Month({formattedMonth}) :</p>
                                    <p>{ApiCallsList?.Total_API_Call?.thisMonth || 0}</p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p>This Year({formattedYear}) :</p>
                                    <p>{ApiCallsList?.Total_API_Call?.thisYear || 0}</p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p>Lifetime:</p>
                                    <p>{ApiCallsList?.Total_API_Call?.lifetime || 0}</p>
                                </div>
                            </div>
                        </Col>
                        {/* Top API Calls */}
                        <Col lg={6}>
                            <div className="p-3 cardDesign">
                                <h4>Top API Calls</h4>
                                <div className="d-flex justify-content-between">
                                    <p>Api </p>
                                    <p>Count</p>
                                </div>
                                {ApiCallsList?.Total_API_Call_LIST?.length > 0 ? (
                                    ApiCallsList?.Total_API_Call_LIST.map((api, index) => (
                                        <div key={index} className="d-flex justify-content-between">
                                            <p>{index + 1}. {api?._id.replace("/api/v1/tradingApis", "") || "API URL"} :</p>
                                            <p>{api?.count || 0}</p>
                                        </div>
                                    ))
                                ) : (
                                    <p>No Data Found</p>
                                )}
                            </div>
                        </Col>
                    </Row>

                    <Row className="mb-3 ">
                        {/* Newest API Calls */}
                        <Col lg={6}>
                            <div className="p-3 cardDesign">
                                <h4>Newest API Calls</h4>
                                <div className="d-flex justify-content-between">
                                    <p>Api</p>
                                    <p>Time</p>
                                </div>
                                {ApiCallsList?.Newest_API_Call?.length > 0 ? (
                                    ApiCallsList?.Newest_API_Call.map((api, index) => (
                                        <div key={index} className="d-flex justify-content-between">
                                            <p>{index + 1}. {api?.endpoint.replace("/api/v1/tradingApis", "") || "API URL"} :</p>
                                            <p>
                                                {DATE_FORMAT_TIME_(api?.createdAt)}
                                            </p>
                                        </div>
                                    ))
                                ) : (
                                    <p>No Data Found</p>
                                )}
                            </div>
                        </Col>
                        {/* IP Source API Calls */}
                        <Col lg={6}>
                            <div className="p-3 cardDesign">
                                <h4>Newest API Calls by IP Source</h4>
                                <div className="d-flex justify-content-between">
                                    <p>Ip</p>
                                    <p>Count</p>
                                </div>
                                {ApiCallsList?.IP_Source_API_Call?.length > 0 ? (ApiCallsList?.IP_Source_API_Call.map((api, index) => (
                                    <div key={index} className="d-flex justify-content-between">
                                        <p>{index + 1}. {api?._id || "API URL"} :</p>
                                        <p>{api?.count || 0}</p>
                                    </div>
                                )))
                                    :
                                    <p>No Data Found</p>
                                }
                            </div>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col lg={6}>
                            <div className="p-3 cardDesign">
                                <h4>API Validity</h4>
                                <TotalApiCallsPie data={ApiValidityList?.validityStatus} />
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="p-3 cardDesign">
                                <h4>Newest 4xx Errors</h4>
                                <TableData
                                    userListing={ApiValidityList?.newest4xx}
                                    setFilter={setFilter}
                                    filter={filter}
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row className="mb-3 ">
                        <Col lg={6}>
                            <div className="p-3 cardDesign">
                                <h4>Status Codes</h4>
                                <StatusCodePieChart data={ApiValidityList?.statusCounts} />
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="p-3 cardDesign">
                                <h4>4xx Errors By Endpoints</h4>
                                <BarChartWithData data={ApiValidityList?.fourxxByEndpoint} />
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-3 ">
                        <Col lg={12} >
                            <div className="p-3 cardDesign">
                                <FilterComponent
                                    filter={tableFilter}
                                    onChange={(e) => handleDataChange(e.target.name, e.target.value)}
                                    onClear={clearFilters}
                                />
                                <LogDataTable
                                    logData={logData?.apiLogsList}
                                    setFilter={setTableFilter}
                                    filter={tableFilter}
                                    totalCount={totalCount}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.Auth,
        userProfile: state?.persistStore?.userProfile,
    };
};

function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDashboard);
